import React from 'react';
import { Typography, withStyles } from '@material-ui/core';

const styles = theme => ({
  header: {
    ...theme.header.mainHeader,
  },
  subheader: {
    ...theme.header.subHeaderText,
  },
});

const SectionHeader = ({ classes, title, children }) => {
  if (title === 'Overview') {
    return <Typography className={classes.header}>{title}</Typography>;
  }
  return (
    <>
      <Typography className={classes.header}>{title}</Typography>
      {children || <Typography className={classes.subheader}>Transmitted Returns</Typography>}
    </>
  );
};

export default withStyles(styles)(SectionHeader);
